var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel margin--bottom granary-right-panel" },
    [
      _c(
        "bar-card",
        { attrs: { bg: "border-new" } },
        [
          _c("g-title", { attrs: { bg: "jyzt" } }, [_vm._v("经营主体情况")]),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "zt-box flex" },
              [
                _c("img", {
                  staticClass: "zt-bg",
                  attrs: {
                    src: require("images/granary/zzy/jyzt-bg-new.png"),
                    alt: "",
                  },
                }),
                _vm._l(_vm.ztList, function (item, i) {
                  return _c("div", { key: i, staticClass: "zt-item" }, [
                    _c("div", { staticClass: "zt-item-t" }, [
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(item.num)),
                      ]),
                      _c("span", { staticClass: "dw" }, [
                        _vm._v("(" + _vm._s(item.unit) + ")"),
                      ]),
                    ]),
                    _c("div", { staticClass: "zt-item-m" }, [
                      _vm._v(" " + _vm._s(item.name) + " "),
                    ]),
                    _c("div", { staticClass: "zt-item-b" }, [
                      _c("img", { attrs: { src: item.icon, alt: "" } }),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }